module.exports = __webpack_public_path__ + "static/media/image 96.36f68660.webp";